import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// TODO: define this
interface User {
  username: string;
  isActive: boolean;
  [key: string]: any;
}

interface ConnectedUsersState {
  initialLoad: boolean;
  users: User[];
}

const connectedUsersSlice = createSlice({
  name: 'connectedUsers',
  initialState: null as ConnectedUsersState | null,
  reducers: {
    setConnectedUsers: (state, action: PayloadAction<User[]>) => {
      return { initialLoad: true, users: action.payload };
    },
    userConnected: (state, action: PayloadAction<User>) => {
      if (state) {
        return {
          ...state,
          users: [...state.users, { ...action.payload, isActive: true }],
        };
      } else {
        return { initialLoad: false, users: [action.payload] };
      }
    },
    userDisconnected: (state, action: PayloadAction<{ username: string }>) => {
      if (!state) return state;

      return {
        ...state,
        users: state.users.filter(
          (x) => x.username !== action.payload.username
        ),
      };
    },
    clearConnectedUsers: (state) => {
      return null;
    },
    userActive: (state, action: PayloadAction<string>) => {
      if (!state) return state;

      return {
        ...state,
        users: state.users.map((x) =>
          x.username === action.payload ? { ...x, isActive: true } : x
        ),
      };
    },
    userInactive: (state, action: PayloadAction<string>) => {
      if (!state) return state;

      return {
        ...state,
        users: state.users.map((x) =>
          x.username === action.payload ? { ...x, isActive: false } : x
        ),
      };
    },
  },
});

export const {
  setConnectedUsers,
  userConnected,
  userDisconnected,
  clearConnectedUsers,
  userActive,
  userInactive,
} = connectedUsersSlice.actions;

export default connectedUsersSlice.reducer;
